<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <section class="form-section">
            <div class="tabs">
              <div
                class="tab__link"
                :class="{ active: layout }"
                @click="switchTab(true)"
              >
                Your Gift
              </div>
              <div
                class="tab__link"
                :class="{ active: !layout }"
                @click="switchTab(false)"
              >
                Sponsorship
              </div>
            </div>

            <div v-if="layout">
              <header>
                <h4>Your Gift</h4>
              </header>
              <div class="form__field">
                <FormRow inline style="display: flex">
                  <AmountSelector />
                </FormRow>

                <ErrorLabel field="amount" />
              </div>
            </div>
            <div v-else>
              <header>
                <h4>The program you would like to sponsor</h4>
              </header>
              <div class="form__field">
                <FormRow>
                  <FormLabel class="control-label"><b> Program: </b></FormLabel>
                </FormRow>
                <div class="series__type">
                  <FormLabel for="generald" name="program">
                    <input
                      id="generald"
                      name="program"
                      type="radio"
                      :checked="getValue('custom.seriesType') === 'General Donation'"
                      @click="selectProgram('General Donation', null)"
                    />
                    General Donation
                  </FormLabel>
                  <FormLabel for="dafg" name="program">
                    <input
                      id="dafg"
                      name="program"
                      type="radio"
                      :checked="getValue('custom.seriesType') === 'Daf Yomi'"
                      @click="selectProgram('Daf Yomi', null)"
                    />
                    Daf Yomi
                  </FormLabel>
                  <FormLabel
                    v-for="(serie, index) in series"
                    :for="`type${index}`"
                    name="program"
                    :key="serie.id"
                  >
                    <input
                      :id="`type${index}`"
                      name="program"
                      type="radio"
                      @click="selectProgram(serie.name, serie.id.toString(), serie.donationEmail, serie.name)"
                    />
                    {{ serie.name }}
                  </FormLabel>
                </div>
                <FormRow>
                  <FormLabel class="control-label"> <b>Donation Amount:</b> </FormLabel>
                </FormRow>

                <div class="doantion__dates">
                  <div class="styled-radio-container--ou-donation type-selector">
                    <FormLabel for="donationShiurType-day">
                      <input
                        type="radio"
                        name="donationShiurType"
                        id="donationShiurType-day"
                        @click="selectSponsorshipType('day')"
                        :checked="getValue('custom.sponsorshipType') == 'day'"
                      />
                      $250 per day listing
                    </FormLabel>

                    <FormLabel for="donationShiurType-week">
                      <input
                        type="radio"
                        name="donationShiurType"
                        id="donationShiurType-week"
                        @click="selectSponsorshipType('week')"
                        :checked="getValue('custom.sponsorshipType') == 'week'"
                      />
                      $1,000 1 week listing
                    </FormLabel>
                    <FormLabel for="donationShiurType-month">
                      <input
                        type="radio"
                        name="donationShiurType"
                        id="donationShiurType-month"
                        @click="selectSponsorshipType('month')"
                        :checked="getValue('custom.sponsorshipType') == 'month'"
                      />
                      $3,600 1 month listing
                    </FormLabel>
                  </div>
                </div>
                <br />
                <FormRow>
                  <FormLabel class="control-label" style="max-width: 100%">
                    Date you would like to Sponsor
                  </FormLabel>
                </FormRow>

                <div class="donation-type">
                  <FormRow
                    inline
                    style="max-width: 50%; margin-bottom: 10px"
                    v-if="getValue('custom.sponsorshipType') == 'week'"
                  >
                    <input
                      type="date"
                      class="date-input"
                      @change="setDate(new Date($event.target.value))"
                    />
                  </FormRow>
                  <FormRow
                    inline
                    style="max-width: 50%; margin-bottom: 10px"
                    v-else-if="getValue('custom.sponsorshipType') == 'month'"
                  >
                    <input
                      type="date"
                      class="date-input"
                      @change="setMonthDate(new Date($event.target.value))"
                    />
                  </FormRow>
                  <FormRow
                    inline
                    style="max-width: 50%; margin-bottom: 10px"
                    v-else-if="getValue('custom.sponsorshipType') == 'day'"
                  >
                    <input
                      type="date"
                      class="date-input"
                      @change="setdayDate(new Date($event.target.value))"
                    />
                  </FormRow>
                  <ErrorLabel field="custom.startDate" />
                </div>

                <div class="form-group form-group--inline" style="">
                  <div>
                    <label
                      for="dedicationMessage"
                      class="control-label"
                      style="max-width: 100%"
                      >Dedicate your gift in honor of or in memory of a loved one</label
                    >
                    <div class="">
                      <FormInput
                        type="text"
                        field="custom.dedicationMessage"
                        class="width-full"
                      />
                      <div class="sub__label">
                        Please enter the dedication/message that you would like to
                        appear/be announced
                      </div>
                    </div>
                  </div>
                </div>

                <FormRow>
                  <FormLabel class="control-label"> Special Instructions </FormLabel>
                </FormRow>
                <FormRow>
                  <FormInput type="textarea" class="width-full" field="custom.comments" />
                </FormRow>
              </div>
            </div>
          </section>
          <section class="form-section">
            <header>
              <h4>Your contact information</h4>
            </header>
            <div class="form__field">
              <FormRow inline>
                <FormCol field="title" :flex="1" />
                <FormCol field="firstName" :flex="2" />
                <FormCol field="lastName" :flex="2" />
              </FormRow>
              <FormRow inline>
                <FormCol field="email" />
                <FormCol field="phone" />
              </FormRow>
              <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>  
            </div>
          </section>
          <section class="form-section">
            <header>
              <h4>Billing Information</h4>
            </header>
            <div class="form__field">
              <DonorAddress />
            </div>
          </section>
          <section class="form-section">
            <header>
              <h4>Payment Information</h4>
            </header>
            <div class="form__field">
              <FormRow inline>
                <FormCol field="card" :showLabel="false" />
              </FormRow>
            </div>
          </section>
          <PaymentButton showAmount btnText="Donate" />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  ref,
  defineComponent,
  onMounted,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

export default defineComponent({
  head() {
    return {
      script: [
        {
          src: "https://doublethedonation.com/api/js/ddplugin.js",
        },
      ],
    };
  },
  setup(props) {
    const { setValue, getValue, form, submit, testMode } = usePaymentForm();
    const series = ref([]);

    // meed too add in callback
    setValue(
      "callback",
      testMode
        ? "https://admin-outorah.oudev.org/outorahDonationCallback"
        : "https://admin.outorah.org/outorahDonationCallback"
    );

    const params = queryParams();

    const layout = ref(true);
    setValue("custom.programId", null);
    setValue("custom.dafType", null);
    setValue("custom.dateOption", null);
    setValue("custom.startDate", null);
    setValue("custom.endDate", null);
    setValue("custom.programId", null);

    function switchTab(isGift: boolean) {
      layout.value = isGift;
      if (isGift) {
        setValue("custom.seriesType", "General Donation");
        setValue("custom.sponsorshipType", null);
        setValue("custom.dafType", null);
        setValue("applications.0.campaign", "Direct Mail");
        setValue("applications.0.department", "OU_Torah");
        setValue("applications.0.subCampaign", null);
        setValue("custom.dateOption", null);
        setValue("custom.startDate", null);
        setValue("custom.endDate", null);
        setValue("custom.programId", null);
        setValue("amount", null);
      } else {
        setValue("custom.seriesType", "General Donation");
        setValue("custom.sponsorshipType", "day");
        setValue("custom.programId", null);
        setValue("custom.dafType", null);
        setValue("amount", "250");
        setValue("custom.dateOption", "Day");
        setValue("applications.0.department", "OU_Torah");
        setValue("applications.0.campaign", "Direct Mail");
        setValue("applications.0.subCampaign", null);
      }
    }

    function selectSponsorshipType(type: string) {
      setValue("custom.sponsorshipType", type);
      if (type === "week") {
        setValue("amount", "1000");
        setValue("custom.dateOption", "Week");
      } else if (type === "month") {
        setValue("amount", "3600");
        setValue("custom.dateOption", "Month");
      } else if (type === "day") {
        setValue("amount", "250");
        setValue("custom.dateOption", "Day");
      }
    }

    function selectProgram(type: string, programId: string | null, donationEmail?: string, subCampaign?: string | null) {
      setValue("custom.seriesType", type);
      setValue("custom.programId", programId);
      if (donationEmail) setValue("custom.donationEmail", donationEmail);
      setValue("applications.0.subCampaign", subCampaign || null);
      if (type === "Daf Yomi") {
        setValue("custom.dafType", "daf");
        setValue("applications.0.department", "OU_Torah");
        setValue("applications.0.campaign", "All Daf");
      } else if (type === "Torat Imecha Nach Yomi" || type === "Torat Imecha Parsha") {
        setValue("applications.0.department", "WomensInitative");
        setValue("applications.0.campaign", "Torat Imecha");
      } else {
        setValue("applications.0.department", "OU_Torah");
        setValue("custom.dafType", null);
        setValue("applications.0.campaign", "Direct Mail");
      }
    }

    onMounted(() => {
      fetch(
        process.env.NODE_ENV == "production"
          ? "https://outorah.org/allDonateSeries"
          : "https://outorah.oudev.org/allDonateSeries"
      )
        .then((x) => x.json())
        .then((x) => {
          series.value = x.filter((x: any) => x.allDafType != "Supplemental Clips");
        });
    });

    function setDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 6)
        ).toISOString()
      );
    }

    function setdayDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
        ).toISOString()
      );
    }

    function setMonthDate(date: Date) {
      //needs to be ipdated to first and end of month
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth() + 1, date.getDate())
        ).toISOString()
      );
    }

    return {
      form,
      layout,
      switchTab,
      selectSponsorshipType,
      selectProgram,
      getValue,
      setValue,
      series,
      submit,
    };
  },
});
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
  background: #fff;
  font-size: 16px;
  color: #222;
  line-height: 1.4;
  font-family: "proxima-nova-condensed", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 400;
  margin: 0;
  padding: 0;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep h2 {
  font-weight: 900;
  margin-bottom: 0;
  color: #365ba5;
  font-size: 20px;
  text-transform: capitalize;
  padding: 20px;
  margin-top: 0px;
}
::v-deep .radio-part {
  min-width: 31.33333% !important;
  max-width: 31.33333% !important;
  &:nth-child(3n) {
    padding-right: 0 !important;
  }
}
::v-deep .amount_other__wrapper {
  max-width: 29.666% !important;
}
::v-deep div[data-amount="12"] {
  order: 1;
  margin-left: 2%;
  padding-right: 0 !important;
}

::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="72"] {
  padding: 8px 0 !important;
  display: block !important;
  &:after {
    content: "most popular choice";
    font-size: 11px;
    width: 100%;
    display: block;
    color: #666;
    margin-top: 3px;
  }
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]:checked
  + label[data-amount="12"]:after {
  color: white;
}
::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]:not(:checked)
  + label[data-amount="72"] {
  background: #eee7fd;
}
.tabs {
  display: flex;
  justify-content: center;
  .tab__link {
    border: none;
    background-color: #eee;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    flex: 1;
    text-align: center;
    font-size: 16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    &.active {
      background: #365ba5;
      color: #fff;
    }
  }
}
.form-section {
  background: #f9f9f9;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
  padding-bottom: 15px;
  header {
    h4 {
      font-weight: 900;
      margin-bottom: 0px;
      color: #365ba5;
      font-size: 20px;
      text-transform: capitalize;
      padding: 20px;
    }
    border-bottom: 1px solid #365ba5;
    margin-bottom: 20px;
  }
}

.form__field {
  padding: 20px;
}

.control-label {
  flex: 1;
  font-size: 14px;
  color: #222;
  max-width: 150px;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
}
.sub__label {
  font-weight: 200;
  font-size: 14px;
  display: block;
  margin-top: 3px;
  margin-bottom: 8px;
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
.series__type {
  width: 100%;
  margin-bottom: 20px;
  label {
    flex: 1;
  }
}
//type selector
.type-selector,
.main-selector {
  // display: flex;
  // align-items: center;
  // justify-content: center;
  // .radio-part {
  //   min-width: 33.333%;
  //   max-width: 33.333%;
  //   text-transform: uppercase;
  //   font-size: 13px;
  // }
}
</style>
